import type { TourDefinition } from '../types'

export const workflowsTour: TourDefinition = {
  id: 'workflows',
  title: 'Workflows Tour',
  description: 'Create, version, and deploy workflows to your BYOK engines.',
  icon: 'Workflow',
  route: '/tenant/workflows',
  estimatedMinutes: 3,
  steps: [
    {
      element: '[data-tour-id="workflows-list"]',
      popover: {
        title: 'Your Workflows',
        description: 'All workflows in this tenant. Click any row to view versions, executions, and deployment history.',
      },
      aiContext: 'How do I organize workflows using tags and categories?',
    },
    {
      element: '[data-tour-id="new-workflow-btn"]',
      popover: {
        title: 'Create a Workflow',
        description: 'Start from scratch or import from a template. Choose your target engine: Dagster, Airflow, or Langflow.',
      },
      aiContext: 'Which workflow engine should I choose for my use case?',
    },
    {
      element: '[data-tour-id="workflow-status-filter"]',
      popover: {
        title: 'Filter by Status',
        description: 'Filter workflows by active, draft, archived, or deployment status.',
      },
      aiContext: 'What does the workflow draft vs active status mean for execution?',
    },
    {
      element: '[data-tour-id="workflow-tags"]',
      popover: {
        title: 'Tags and Categories',
        description: 'Organize workflows with tags for easy discovery. Tags support fuzzy search.',
      },
      aiContext: 'How do tags and categories help with workflow governance?',
    },
  ],
}
